var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIfcSiteSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8799 16.46C20.4758 17.4583 23.326 17.5846 26 16.82L25.6207 16H27.8223L28.7315 18H26.5106L26.4 17.75C25.0236 18.1021 23.6105 18.2901 22.19 18.31C20.5692 18.3306 18.9618 18.0139 17.4699 17.38C16.6071 16.9946 15.7805 16.5327 15 16C13.8213 15.1186 12.4505 14.5291 11 14.28C9.64899 14.1293 8.28144 14.2866 6.99995 14.74L6.87908 15H4.63226L5.54149 13H7.71446L7.45995 13.55C8.64902 13.2321 9.88782 13.1438 11.11 13.29C12.3741 13.4708 13.5848 13.921 14.66 14.61C16.3588 14.5961 18.0317 14.1924 19.5499 13.43C20.7272 12.8272 21.7766 12.002 22.6399 11H21.86L21.28 9H22.4799H24.6399L26 11.9915L23.7705 12L23.53 11.48C22.5584 12.6567 21.3573 13.623 20 14.32C18.7898 14.9319 17.4846 15.3343 16.14 15.51C16.696 15.8687 17.2776 16.1862 17.8799 16.46Z",
    fill: "#252A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3676 15H25.1581L24.233 13H26.4584L27.3676 15Z",
    fill: "#252A2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26841 18H5.48439L6.41418 16H4.17764L3.26841 18Z",
    fill: "#252A2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63995 11L8.17721 12H5.9961L7.35995 9H10.72L10.14 11H8.63995Z",
    fill: "#252A2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0195 19H2.8138L1.44995 22H6.99995L7.57 20L4.54995 20.01L5.0195 19Z",
    fill: "#252A2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1861 19H26.953L27.4 20.01L24.43 20L25 22H30.5499L29.1861 19Z",
    fill: "#252A2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46 20.0028L9 22H15L15.06 20L9.46 20.0028Z",
    fill: "#252A2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L16.94 20.01H22.54L23 22H17Z",
    fill: "#252A2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L20.46 11H16.67L16.6 9H20Z",
    fill: "#252A2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.41 9L15.34 11H11.54L12 9H15.41Z",
    fill: "#252A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfcSiteSvg);
export default __webpack_public_path__ + "static/media/IfcSite_svg.b571adf362e54b4531c18c00d7b68786.svg";
export { ForwardRef as ReactComponent };